export default "__VITE_ASSET__4776c919__"